import AppRoutes from "./components/appRoutes";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import "./css/misc.css";
import "./css/appColor.css";
import { ToastContainer } from "react-toastify";

const App = () => {
  return (
    <>
      <AppRoutes />
      <ToastContainer />
    </>
  );
};

export default App;
